<template>
  <v-card class="v-completed-component text-center">
    <v-card-title>
      <v-row justify="center">
        <LeadtributorCloudIconColor/>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <h1>{{ $t('login.completedTitle') }}</h1>
    </v-card-subtitle>
    <div class="description">{{ $t('login.completedDescription') }}</div>
    <div class="py-5">
      <CheckIconLg/>
    </div>
    <ButtonPrimaryDark @click="emitToLoginEvent">
      <template v-slot:text>{{ $t('login.goToLogin') }}</template>
    </ButtonPrimaryDark>
    <v-card-text class="text-left pt-4 pb-2 px-0">
      <slot name="privacy"></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="px-0 pb-0">
      <v-row
        align="center"
        justify="space-around"
      >
        <slot></slot>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import LeadtributorCloudIconColor from '@/components/icons/LeadtributorCloudIconColor'
import CheckIconLg from '@/components/icons/CheckIconLg'
import ButtonPrimaryDark from '@/components/buttons/templates/ButtonPrimary'

export default {
  name: 'CompletedComponent',
  components: {
    ButtonPrimaryDark,
    CheckIconLg,
    LeadtributorCloudIconColor
  },
  setup (_, { emit }) {
    function emitToLoginEvent () {
      emit('toLogin')
    }

    return { emitToLoginEvent }
  }
}
</script>


<style scoped lang="scss">
.v-completed-component {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 24px 32px 32px;
  margin: 0 auto;
  max-width: 338px;

  .v-card__subtitle {
    margin-top: 32px;
  }

  h1 {
    color: #3E4041;
    font-size: 30px;
    font-weight: 300;
    line-height: 38px;
  }

  .description {
    color: #8EA2A8;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 32px;
  }

  .v-divider {
    margin-top: auto;
  }

  .v-card__text {
    color: #8EA2A8;
    font-size: 14px;
    line-height: 17px;
  }
}
</style>

<!-- global style to override framework styling  -->
<style lang="scss">
.v-application .v-completed-component .v-card__text a {
  color: #8EA2A8;
  text-decoration: underline;
}
</style>
